import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { StickyContainer } from '../StickyContainer';
const containerStyles = css `
  ${theme.typeStyles.titleLargeStyles}
  background-color: ${theme.colors.gray100};
  column-gap: ${theme.spacing.base};
  display: flex;
  padding-bottom: ${theme.spacing.x4};
  padding-left: ${theme.spacing.x4};
  padding-right: ${theme.spacing.x4};
  padding-top: ${theme.spacing.x4};
  width: 100%;
`;
const titleStyles = css `
  ${theme.typeStyles.titleLargeStyles}
  padding-top: ${theme.spacing.base};
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
`;
const DrawerHeader = ({ leftAlignedAddon, rightAlignedAddon, title, zIndex, }) => {
    const stickyContainerStyles = useMemo(() => (zIndex
        ? css `
          z-index: ${zIndex};
        `
        : undefined), [
        zIndex,
    ]);
    return (_jsx(StickyContainer, Object.assign({ css: stickyContainerStyles, position: "top" }, { children: _jsxs("div", Object.assign({ css: containerStyles }, { children: [leftAlignedAddon, title
                    && (_jsx("div", Object.assign({ css: titleStyles }, { children: title }))), rightAlignedAddon] })) })));
};
const MemoizedDrawerHeader = memo(DrawerHeader);
export { MemoizedDrawerHeader as DrawerHeader };
// MC-1068 Temporary hack for Storybook.
export default DrawerHeader;
